// Students are considered "active" once their HSGY (high school graduation
// year) falls within the trailing 5-year window. The window rolls forward
// every July 1st: from July 1st through June 30th the active floor stays the
// same, then advances by one year on July 1st.
//
// Example: any date from 2026-07-01 through 2027-06-30 has a floor of 2021.
// On 2027-07-01 the floor advances to 2022.
export const getActiveHSGYCutoffYear = (referenceDate = new Date()) => {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth(); // 0-indexed; June = 5, July = 6
  const effectiveYear = month >= 6 ? year : year - 1;
  return effectiveYear - 5;
};
